import { Component } from 'react'

import classNames from 'classnames'
import PropTypes from 'prop-types'

import Grid from 'components/Core/Grid/Grid'
import StaticCount from 'components/Core/StaticCount/StaticCount'

import styles from './StatusFilters.module.css'
import messages from 'containers/OrderList/OrderList.messages'

export const filterTypeMap = {
  ordersNotes: 'ALL_NOTES',
  ordersWithQuantities: 'NOTES_WITH_QUANTITIES',
  ordersWithoutQuantities: 'NOTES_WITHOUT_QUANTITIES',
  ordersPending: 'PENDING',
  ordersApproved: 'APPROVED',
  ordersShipped: 'SHIPPED',
  ordersCancelled: 'CANCELLED',
  ordersDraft: 'IN_PROGRESS',
}

class StatusFilters extends Component {
  onSelect = (fields) => (index) => {
    const {
      toggleSelectQuickFilter,
      selectedFilters,
      handlePaginationReset,
      trackSelectFilter,
    } = this.props
    handlePaginationReset()
    const withQuantitiesFilter = selectedFilters.some(
      (filter) => filter.id === 'NOTES_WITH_QUANTITIES',
    )
    const withoutQuantitiesFilter = selectedFilters.some(
      (filter) => filter.id === 'NOTES_WITHOUT_QUANTITIES',
    )
    const withAllNotes = selectedFilters.some(
      (filter) => filter.id === 'ALL_NOTES',
    )
    const toSwitchWithQuantities =
      (!withAllNotes && !withQuantitiesFilter) ||
      (withAllNotes && withQuantitiesFilter)
    const toSwitchWithoutQuantities =
      (!withAllNotes && !withoutQuantitiesFilter) ||
      (withAllNotes && withoutQuantitiesFilter)

    let checkboxName = messages[fields[index]]
    if (fields.length === 2) {
      checkboxName = `${messages.ordersWithQuantitiesTitle} - ${checkboxName}`
    }

    trackSelectFilter({ checkboxName })

    if (fields[index] === 'ordersNotes') {
      toggleSelectQuickFilter([
        {
          id: 'ALL_NOTES',
          filterDataKey: 'status',
        },
        toSwitchWithQuantities && {
          id: 'NOTES_WITH_QUANTITIES',
          filterDataKey: 'status',
        },
        toSwitchWithoutQuantities && {
          id: 'NOTES_WITHOUT_QUANTITIES',
          filterDataKey: 'status',
        },
      ])
      return
    }
    const filterToChange = filterTypeMap[fields[index]]
    if (
      fields[index] === 'ordersWithQuantities' ||
      fields[index] === 'ordersWithoutQuantities'
    ) {
      // To deselect ALL_NOTES when with and without quantities is deselected
      if (
        (!withoutQuantitiesFilter &&
          withQuantitiesFilter &&
          filterToChange === 'NOTES_WITH_QUANTITIES') ||
        (!withQuantitiesFilter &&
          withoutQuantitiesFilter &&
          filterToChange === 'NOTES_WITHOUT_QUANTITIES')
      ) {
        toggleSelectQuickFilter([
          {
            id: filterToChange,
            filterDataKey: 'status',
          },
          withAllNotes && {
            id: 'ALL_NOTES',
            filterDataKey: 'status',
          },
        ])
        return
      }
      toggleSelectQuickFilter([
        {
          id: filterToChange,
          filterDataKey: 'status',
        },
        !withAllNotes && {
          id: 'ALL_NOTES',
          filterDataKey: 'status',
        },
      ])
      return
    }
    toggleSelectQuickFilter([
      {
        id: filterToChange,
        filterDataKey: 'status',
      },
    ])
  }

  getStaticCounts = () => {
    const {
      ordersCancelled,
      ordersApproved,
      ordersShipped,
      ordersWithQuantities,
      ordersWithoutQuantities,
      ordersPending,
      ordersDraft,
    } = this.props

    const ordersNotes =
      ordersWithQuantities === null && ordersWithoutQuantities === null
        ? null
        : ordersWithQuantities + ordersWithoutQuantities

    return {
      ordersCancelled,
      ordersApproved,
      ordersShipped,
      ordersWithQuantities,
      ordersWithoutQuantities,
      ordersPending,
      ordersNotes,
      ordersDraft,
    }
  }

  formatStaticCounts = () => {
    const { selectedFilters } = this.props

    const staticCounts = this.getStaticCounts()
    const staticCountsFields = [
      ['ordersDraft'],
      ['ordersNotes'],
      ['ordersWithQuantities', 'ordersWithoutQuantities'],
      ['ordersPending'],
      ['ordersApproved'],
      ['ordersShipped'],
      ['ordersCancelled'],
    ]
    return staticCountsFields.map((fields) => ({
      key: fields[0],
      items: fields.map((field) => ({
        title: messages[field],
        count: staticCounts[field],
      })),
      separator: fields.length < 2,
      header: fields.length < 2 ? null : messages.ordersWithQuantitiesTitle,
      selectable: true,
      onSelect: this.onSelect(fields),
      checked: fields.map((field) =>
        selectedFilters.some((filter) => filter.id === filterTypeMap[field]),
      ),
    }))
  }

  render() {
    const staticCounts = this.formatStaticCounts()
    return staticCounts.map((staticCount) => {
      const multiple = staticCount.items && staticCount.items.length > 1
      return (
        <Grid.Col
          key={staticCount.key}
          sm={1}
          md={1}
          lg={1}
          className={classNames({ [styles.multiple]: multiple })}
        >
          <StaticCount {...staticCount} />
        </Grid.Col>
      )
    })
  }
}

StatusFilters.propTypes = {
  ordersCancelled: PropTypes.number,
  ordersApproved: PropTypes.number,
  ordersShipped: PropTypes.number,
  ordersWithQuantities: PropTypes.number,
  ordersWithoutQuantities: PropTypes.number,
  ordersPending: PropTypes.number,
  ordersDraft: PropTypes.number,
  toggleSelectQuickFilter: PropTypes.func,
  selectedFilters: PropTypes.array,
  handlePaginationReset: PropTypes.func,
  trackSelectFilter: PropTypes.func,
}

StatusFilters.defaultProps = {
  ordersCancelled: 0,
  ordersApproved: 0,
  ordersShipped: 0,
  ordersWithQuantities: 0,
  ordersWithoutQuantities: 0,
  ordersPending: 0,
  ordersDraft: 0,
  toggleSelectQuickFilter: () => {},
  selectedFilters: [],
  handlePaginationReset: () => {},
  trackSelectFilter: () => {},
}

export default StatusFilters
